export default {"src":"/_next/static/media/github.9351cf59.svg","height":26,"width":26};